import useAuth from 'hooks/useAuth';
import normalizeEmail from 'utils/normalizeEmail';

export default function useHandleAccess() {
  const { db } = useAuth();
  const handleAccess = async (email: string, access: boolean) => {
    const normalized = normalizeEmail(email);
    if (!normalized) throw new Error('No email found for this contact');

    // Some existing records were keyed by an unnormalized email. Keep reads
    // compatible with those docs, but migrate/delete them whenever this control
    // is used so future access checks have one canonical document.
    const raw = typeof email === 'string' ? email : '';
    const refs = Array.from(
      new Set([normalized, raw].filter((id) => id && !id.includes('/')))
    ).map((id) => db.collection('access').doc(id));
    const canonicalRef = db.collection('access').doc(normalized);
    const batch = db.batch();

    if (access) {
      batch.set(canonicalRef, { enabled: true }, { merge: true });
      refs.filter((ref) => ref.path !== canonicalRef.path).forEach((ref) => batch.delete(ref));
    } else {
      refs.forEach((ref) => batch.delete(ref));
    }

    await batch.commit();
  };

  return handleAccess;
}
